/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesFileTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for File Type Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, December 02, 2018 - 05:56:06 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/02/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const FileTypeList = Loadable({
    loader: () => import('../containers/FileTypes/FileTypeListContainer'),
    loading: Loading,
});

export const FileTypeForm = Loadable({
    loader: () => import('../containers/FileTypes/FileTypeEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesFileTypes.js